<section class="container-fluid" [formGroup]="group">
    <div class="row" *ngIf="meetingID === null">
        <div class="col-pull-right col-sm-4">          
                <mat-checkbox  formControlName="SelectAll" color="primary"><h4>Select All</h4></mat-checkbox>         
        </div>
    </div>
    <div class="contacts-roster" formArrayName="Roster">
        <!-- <div *ngIf="meetingID === null" class="existingContacts"> -->
        <div class="existingContacts mat-elevation-z2 mb-4">
            <div class="row align-items-center mb-2" *ngFor="let w of slicedArray" [formGroup]="w">
                <div class="d-none hidden">{{w.get("id").value}}</div>
                <div class="col-sm-1">
                    <mat-checkbox formControlName="isSelected" color="primary"></mat-checkbox>
                </div>
                <div class="col-sm-2">
                    {{w.get('firstName').value}}
                    <!-- <mat-form-field appearance="fill" floatLabel="never">
                        <input matInput [value]="w.get('firstName').value" readonly />
                  </mat-form-field> -->
                </div>
                <!-- <div class="col-sm-2"> {{w.get("middleName").value}}</div> -->
                <div class="col-sm-3">
                    {{w.get('lastName').value}}
                    <!-- <mat-form-field appearance="fill" floatLabel="never">
                        <input matInput [value]="w.get('lastName').value" readonly />
                  </mat-form-field> -->
                </div>
                <div class="col-sm-4">
                    {{w.get('email').value}}
                    <!-- <mat-form-field appearance="fill" floatLabel="never">
                        <input matInput [value]="w.get('email').value" readonly />
                  </mat-form-field> -->
                </div>
                <div class="col-sm-2">
                    {{w.get('mobilePhone').value}}
                    <!-- <mat-form-field appearance="fill" floatLabel="never">
                        <input matInput [value]="w.get('mobilePhone').value" readonly />
                  </mat-form-field> -->
                </div>
            </div>
            <mat-divider></mat-divider>
            

            <mat-paginator [length]="totalCount" [pageIndex]="this.pageIndex" [pageSize]="this.pageSize"
                [pageSizeOptions]="[10, 20, 50]" (page)="getNextPage($event)">
            </mat-paginator>
        </div>
        <div class="newContacts mb-4">
            <div class="row" [formGroup]="addContact">
                <div class="col-lg-6 col-12">
                    <div class="row">
                        <div class="col-lg-6 col-12">
                            <mat-form-field> <input type="text" matInput placeholder="First Name" formControlName="firstName" />
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-12">
                            <mat-form-field> <input type="text" matInput placeholder="Last Name" formControlName="lastName" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="row">
                        <div class="col-lg-6 col-12">
                            <mat-form-field> <input type="text" matInput placeholder="Email" formControlName="email" />
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-12">
                            <mat-form-field> <input type="text" matInput placeholder="Mobile Phone" formControlName="mobilePhone" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-3 col-6">
                    <div class="button-row mb-4">
                        <button mat-button mat-raised-button color="primary" *ngIf="showAddButton" class="button-submit"
                            (click)="addRecord(addContact)">Add</button>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="newContactArray.length > 0">
                <div class="col-sm-12">
                    <h4>Added Individuals</h4>
                </div>

            </div>
            <div class="row align-items-center mat-elevation-z2 mb-2" *ngFor="let a of newContactArray.controls" [formGroup]="a" >
                <div class="d-none hidden">{{a.get("id").value}}</div>
                <div class="col-sm-1">
                    <mat-checkbox formControlName="isSelected" color="primary"></mat-checkbox>
                  </div>
                <div class="col-sm-2">{{a.get("firstName").value}}</div>
                <!-- <div class="col-sm-2"> {{a.get("middleName").value}}</div> -->
                <div class="col-sm-3">{{a.get("lastName").value}}</div>
                <div class="col-sm-4">{{a.get("email").value}}</div>
                <div class="col-sm-2">{{a.get("mobilePhone").value}}</div>
            </div>
        </div>
        <!-- <div class="row" *ngIf="newContactArray.length > 0">
            <mat-paginator [length]="totalNewContactCount" [pageIndex]="this.pageNewContactIndex" [pageSize]="this.pageNewContactSize"
                [pageSizeOptions]="[10, 20, 50]" (page)="getNewContactNextPage($event)">
            </mat-paginator>
        </div> -->
    </div>
</section>